import React from 'react';
import { Route, Switch } from 'react-router-dom';

import Todo from './Todo';
import ReminderPage from './ReminderPage';
import BigCalender from './BigCalendar';
import Contacts from './Contacts';
import { withOidcSecure } from '@axa-fr/react-oidc-context';

function Efficiency(props: any) {
  const routeMatch = props.match;

  return (
    <div className="gx-main-content-wrapper">
      <Switch>
        <Route
          path={`${routeMatch.url}/reminders`}
          component={withOidcSecure(ReminderPage)}
        />
        <Route path={`${routeMatch.url}/todo`} component={Todo} />
        <Route path={`${routeMatch.url}/calendar`} component={BigCalender} />
        <Route path={`${routeMatch.url}/contacts`} component={Contacts} />
      </Switch>
    </div>
  );
}

export default Efficiency;
